export const bankAccounts = [
  {
    id: 'bank_nubank',
    organizationId: 'org_3la_labs',
    bank: 'Nubank',
    name: 'Nubank PJ',
    agency: '0001',
    account: '1234567-8',
    type: 'Conta corrente',
    balance: 32450.2,
    inflows: 28500,
    outflows: 9120.4,
    lastTransaction: '04/09/2026',
  },
  {
    id: 'bank_bb',
    organizationId: 'org_3la_labs',
    bank: 'Banco do Brasil',
    name: 'Banco do Brasil',
    agency: '3456-7',
    account: '98765-4',
    type: 'Conta corrente',
    balance: 12300.1,
    inflows: 9200,
    outflows: 4100,
    lastTransaction: '03/09/2026',
  },
  {
    id: 'bank_mp',
    organizationId: 'org_3la_labs',
    bank: 'Mercado Pago',
    name: 'Mercado Pago',
    agency: '—',
    account: 'MP-778899',
    type: 'Carteira digital',
    balance: 4000.02,
    inflows: 6500,
    outflows: 2499.98,
    lastTransaction: '01/09/2026',
  },
];
